import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取账号信息*/
export function GetAccount(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/account/",
        params:data
    })
}

/*获取账号信息*/
export function AccountidInfo(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/accountidlist/",
        params:data
    })
}

/*获取账号编辑信息*/
export function AccountEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/accountedit/",
        params:data
    })
}

/*获取密码编辑信息*/
export function PasswordEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/passwordedit/",
        params:data
    })
}

/*账号编辑*/
export function AccountEdit(data = {}){
    let params = new URLSearchParams();
    params.append('accountid',data.accountid);
    params.append('fullname',data.fullname);
    params.append('personnel',data.personnel);
    params.append('state',data.state);
    params.append('password',data.password)
return instance.request({
        method: "post",
        url: "lzjaiopsbase/accountedit/",
        data:params
    })
}

/*密码修改*/
export function PasswordEdit(data = {}){
    let params = new URLSearchParams();
    params.append('accountid',data.accountid);
    params.append('password',data.password)
return instance.request({
        method: "post",
        url: "lzjaiopsbase/passwordedit/",
        data:params
    })
}

/*账号新增*/
export function AccountAdd(data = {}){
    let params = new URLSearchParams();
    params.append('accountid',data.accountid);
    params.append('fullname',data.fullname);
    params.append('personnel',data.personnel);
    params.append('state',data.state);
    params.append('password',data.password)
    params.append('accountcategory',data.accountcategory)
    params.append('supplierid',data.supplierid)
    params.append('suppliername',data.suppliername)
return instance.request({
        method: "post",
        url: "lzjaiopsbase/accountadd/",
        data:params
    })
}

/*账号删除*/
export function AccountDel(data = {}){
    let params = new URLSearchParams();
    params.append('accountid',data.accountid)
return instance.request({
        method: "post",
        url: "lzjaiopsbase/accountdel/",
        data:params
    })
}

/*角色授权确认*/
export function RoleAuthorizationConfirm(data = {}){
    let params = new URLSearchParams();
    params.append('accountid',data.accountid)
    params.append('authList',data.authList)
return instance.request({
        method: "post",
        url: "lzjaiopsbase/roleauthorization/",
        data:params
    })
}

/*获取授权角色信息*/
export function RoleAuthorization(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/roleauthorization/",
        params:data
    })
}

/*获取所有角色信息*/
export function RoleInfo(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/roleoptions/",
        params:data
    })
}

/*获取授权角色列表*/
export function AuthorizationInfo(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/roleselected/",
        params:data
    })
}